export default __webpack_public_path__ + "static/media/people.f763c1ce.svg";